<template>
  <div class="preferences page">
    <main>
      <div class="preferences__header  pt-24 pb-24">
        <div class="container-fluid">
          <div class="row align-items-center align-items-lg-start">
            <div class="d-none d-lg-block col-1">
              <button @click="$router.go(-1)" class="btn-icon icon-caret-left"></button>
            </div>
            <div class="col-12 col-lg-8">
              <h1 class="h1 text-center text-lg-left">Mijn gegevens</h1>
              <h2 v-if="!$loggedIn" class="h3 d-none d-lg-block text-center text-lg-left">Welkom, u bent niet ingelogd</h2>
            </div>
            <div v-if="!$loggedIn" class="col-12 col-lg-3">
              <div class="h-100 d-flex flex-column align-items-center align-items-lg-end justify-content-end mt-4">
                <button @click.prevent="$login" class="btn-login mb-4">Inloggen bij het IDD</button>
                <button :disabled="favorites.length === 0" @click.prevent="$router.push({ name: 'step1' })" class="btn btn-primary">
                  {{ favorites.length > 1 ? favorites.length : '' }} {{ favorites.length === 1 ? 'voorkeur' : 'voorkeuren' }} definitief maken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="preferences__body  pt-24 pb-24">
        <div class="preferences__body--title">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 offset-lg-1">
                <div class="d-flex align-items-center">
                  <h3 class="h1">Mijn voorkeuren</h3>
                  <h4 class="h5 d-none d-lg-block">{{ favorites.length }} van de {{ $store.state.apiData.objects.length }} appartementen</h4>
                </div>
              </div>
              <div class="col-3 col-lg-2">
                <div class="h-100 d-flex align-items-center justify-content-end">
                  <div class="tooltip-wrap">
                    <a class="tooltip-btn">Info</a>
                    <div class="tooltip-content">
                      Sleep de voorkeuren op volgorde van interesse.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <preferences-list></preferences-list>

      </div>


      <div class="preferences__footer  pt-24 pb-24">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-center justify-content-lg-end">
                <button :disabled="favorites.length === 0" @click.prevent="$router.push({ name: 'step1' })" class="btn btn-primary">
                  {{ favorites.length > 1 ? favorites.length : '' }} {{ favorites.length === 1 ? 'voorkeur' : 'voorkeuren' }} definitief maken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
    import PreferencesList from '../components/PreferencesList.vue'

    export default {
        components: {
            PreferencesList
        },
        computed: {
          favorites () {
            return this.$store.state.favorites
          }
        }
    }
</script>

<style>
  .preferences__header, .preferences__body {
    border-bottom: 1px solid #F2F2F2;
  }

  .preferences__body .h1 {
    margin-bottom: 0;
    margin-right: 12px;
  }
</style>
